import { useSelector, } from 'react-redux';
import { IGlobalStore, IReducerStore, } from '@Store';

export const useSwitchingProfile = (): IGlobalStore['switching_profile'] => {
  return useSelector((store: IReducerStore) => store.global.switching_profile);
};
